import React from 'react';
import { InlineSVG } from '../../../../Components/Icons';
import { colors } from '../../../../globalStyles';
import { categoryToneByLabel } from './AssessmentFlags.copy';
import {
  CategoryBadge,
  ComplexNeedsBadge,
  EmptyStateDiv,
  FlagNameTd,
  FlagsHeaderDiv,
  FlagsTable,
  FlagsTableDiv,
  FlagsTitle,
  FlagsWidget,
  SeverityTd,
} from './AssessmentFlags.styles';
import { AssessmentIndexFlag } from './AssessmentFlags.types';
import {
  formatCategoryLabel,
  formatFlagLabel,
  formatSeverityLabel,
  getSeverityTone,
} from './utils';

export const AssessmentFlags = ({
  flags,
  hasComplexNeeds,
}: {
  flags: AssessmentIndexFlag[];
  hasComplexNeeds: boolean;
}) => (
  <FlagsWidget>
    <FlagsHeaderDiv>
      <FlagsTitle>Flagged Concerns</FlagsTitle>
      {hasComplexNeeds && (
        <ComplexNeedsBadge>
          <InlineSVG icon="alert-circle" size={18} fill={colors.white} />
          Complex Needs
        </ComplexNeedsBadge>
      )}
    </FlagsHeaderDiv>
    <FlagsTableDiv>
      <FlagsTable>
        <thead>
          <tr>
            <th>
              Flag <span aria-hidden="true">&darr;</span>
            </th>
            <th>Severity</th>
            <th>Category</th>
          </tr>
        </thead>
        <tbody>
          {flags.length ? (
            flags.map(flag => {
              const categoryLabel = formatCategoryLabel(flag.category);

              return (
                <tr key={`${flag.flagKey}-${flag.category}`}>
                  <FlagNameTd>{formatFlagLabel(flag.flagKey)}</FlagNameTd>
                  <SeverityTd $tone={getSeverityTone(flag.flagRiskScaleLevel)}>
                    {formatSeverityLabel(flag.flagRiskScaleLevel)}
                  </SeverityTd>
                  <td>
                    <CategoryBadge $tone={categoryToneByLabel[categoryLabel] ?? 'default'}>
                      {categoryLabel}
                    </CategoryBadge>
                  </td>
                </tr>
              );
            })
          ) : (
            <tr>
              <td colSpan={3}>
                <EmptyStateDiv>No assessment flags are available for this student.</EmptyStateDiv>
              </td>
            </tr>
          )}
        </tbody>
      </FlagsTable>
    </FlagsTableDiv>
  </FlagsWidget>
);
